var _jsxFileName = "/home/runner/work/frontend-shared/frontend-shared/src/components/icons/PointerUp.tsx";
import { jsxDEV as _jsxDEV } from "preact/jsx-dev-runtime";
/**
 * Icon generated from pointer-up.svg
 */
export default function PointerUpIcon(props) {
  return _jsxDEV("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "9",
    "data-component": "PointerUpIcon",
    ...props,
    children: _jsxDEV("path", {
      stroke: "currentColor",
      d: "m.5 9 7-8 8 8"
    }, void 0, false, {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 11,
    columnNumber: 5
  }, this);
}
//# sourceMappingURL=PointerUp.js.map